import { ReactNode } from 'react';

import { Box, SxProps } from '@mui/material';

export const IconColorWrapper: React.FC<{ color: string; children: ReactNode; sx?: SxProps }> = ({
  color,
  children,
  sx,
}) => {
  return (
    <Box
      component="span"
      sx={{
        height: `fit-content`,
        width: `fit-content`,
        svg: {
          path: {
            fill: color,
          },
        },
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};
